import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PrevisionDialogComponent } from '../../dialogs/prevision.dialog.component';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { NotificationService } from '../../../../services/notification.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import * as moment from 'moment';
import { of, Subscription } from 'rxjs';
import { mergeAll } from 'rxjs/operators';
import { PrevisionDataSource } from '../../data-sources/previsions.data-source';
import { Prevision } from '../../models/prevision.entity';
import { PrevisionsService } from '../../services/previsions.service';
import { SmsService } from '../../services/sms.service';

class StatusNames {
  static readonly status = {
    1: '1- En Prevision',
    2: '2- Registro',
    3: '3- Inicio carga',
    4: '4- Fin carga',
    5: '5- Despacho de expedición',
    10: '10- Forgasa: Expedición manual',
    11: '11- Forgasa: Otros'
  };
}
interface SyncroData {
  status: string;
  action: any;
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListComponent implements OnInit, AfterViewInit {
  /**
   * Displayed columns array
   */
  displayedColumns: string[] = [
    'TKNUM',
    'ZZFECHALECTURA_E',
    'ENTRY_DATE',
    'EXIT_DATE',
    'QR',
    'SIGNI',
    'NAME1_T',
    'provcli',
    'ARKTX',
    'STTRG',
    'actions',
  ];

  /**
   * Table config array
   */
  tableConfig: any[] = [
    { columnName: 'Nº Transporte', enableSort: true },
    { columnName: 'Generación', pipe: new DatePipe('es'), configPipe: ['d MMM y, H:mm'] },
    { columnName: 'Fecha entrada', pipe: new DatePipe('es'), configPipe: ['d MMM y, H:mm'] },
    { columnName: 'Fecha salida', pipe: new DatePipe('es'), configPipe: ['d MMM y, H:mm'] },
    { columnName: 'QR' },
    { columnName: 'Matrículas' },
    { columnName: 'Transportista' },
    { columnName: 'Destinatario/Proveedor' },
    { columnName: 'Material' },
    {
      columnName: 'Estado',
      enableSort: true,
      pipe: value => {
        return StatusNames.status[Number(value)] || value;
      },
    },
    { columnName: 'actions' },
  ];

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;
  /**
   * BreadcrumbData
   */
  syncroData: SyncroData;

  /**
   * Previsions data source
   */
  previsions: PrevisionDataSource;

  /**
   * Paginator
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Sort
   */
  @ViewChild(MatSort) sort: MatSort;

  /**
   * Total previsions
   */
  totalPrevisions: number;

  /**
   * Filter object
   */
  filter: any = {};

  /**
   * Filter form
   */
  filterForm: FormGroup;
  public sincronized = true;
  public syncroAction: any;

  expandedElement: any;
  movementBackImageSrc: any;
  movementFrontImageSrc: any;
  facialImageSrc: any;

  private syncPrevisionesListSubscription: Subscription;
  private modifiedPrevisionSubscription: Subscription;
  private modifyPrevisonSubscription: Subscription;
  private sendSmsSubscription: Subscription;
  private sortChangeSubscription: Subscription;
  private filterValueChangesSubscription: Subscription;

  /**
   * Constructor
   *
   * @param previsionsService PrevisionssService
   * @param _snackBar Servicio de alertas de material
   * @param dialog Dialogo
   * @param smsService Servicio para el envio de sms's
   * @param simpleDialogService SimpleDialogService
   */
  // tslint:disable-next-line:variable-name
  constructor(
    private previsionsService: PrevisionsService,
    private snackBar: NotificationService,
    private dialog: MatDialog,
    private smsService: SmsService,
    private wsService: WebSocketService
  ) {
    // , public wsService: WebSocketService
    this.breadcrumbData = {
      titles: {
        icon: 'lock_open',
        links: [
          {
            text: 'Previsiones',
          },
        ],
      },
      description: 'Aquí puede ver todos las previsiones y puedes filtrarlas',
    };
    this.syncroAction = () => this.sync();
    this.filterForm = new FormGroup({
      ZZFECHALECTURA_E: new FormGroup({
        start: new FormControl(null),
        end: new FormControl(null),
      }),
      QR: new FormControl(),
      TKNUM: new FormControl(),
      STTRG: new FormControl(),
      SIGNI: new FormControl(),
      todayFilter: new FormControl(),
    });
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.initTodayFilter();
    this.previsions = new PrevisionDataSource(this.previsionsService);
    this.previsions.load();

    this.filterValueChangesSubscription = this.filterForm.valueChanges.subscribe(value => {
      if (value.todayFilter === true) {
        this.filter.today = true;
      } else if (value.ZZFECHALECTURA_E != null && value.ZZFECHALECTURA_E.start != null && value.ZZFECHALECTURA_E.end != null) {
        this.filter.today = false;
        this.filter.ZZFECHALECTURA_E_from = value.ZZFECHALECTURA_E.start.utc().startOf('day').toISOString();
        this.filter.ZZFECHALECTURA_E_to = value.ZZFECHALECTURA_E.end.utc().endOf('day').toISOString();
      } else {
        this.filter.today = false;
      }
      if (value.QR != null) {
        this.filter.QR = value.QR;
      }
      if (value.TKNUM != null) {
        this.filter.TKNUM = value.TKNUM;
      }
      if (value.STTRG != null) {
        this.filter.STTRG = value.STTRG;
      }
      if (value.SIGNI != null) {
        this.filter.SIGNI = value.SIGNI;
      }

      // console.log(JSON.stringify(this.filter));
      this.loadPrevisions();
    });

    this.socketSincro();
  }

  OnDestroy() {
    this.syncPrevisionesListSubscription.unsubscribe();
    this.sortChangeSubscription.unsubscribe();
    this.filterValueChangesSubscription.unsubscribe();
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    this.sortChangeSubscription = this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
    });

    of(this.sort.sortChange, this.paginator.page)
      .pipe(mergeAll())
      .subscribe(() => {
        this.loadPrevisions();
      });

    // this.loadPrevisions();
  }

  /**
   * Load previsions
   */
  loadPrevisions(): void {
    this.previsions.load(this.sort.active, this.sort.direction, this.paginator.pageSize, this.paginator.pageIndex, this.filter);

    this.previsionsService
      .getCount('STTRG', this.sort.direction, this.paginator.pageSize, this.paginator.pageIndex, this.filter)
      //.subscribe((data: { count: number }) => { this.totalPrevisions = data.count; });
      .subscribe((data:any) => { this.totalPrevisions = data.count; });
  }

  /**
   * Clear
   */
  clear() {
    this.filterForm.reset();
    this.filter = {};
    this.loadPrevisions();
    this.paginator.pageIndex = 0;
  }

  setExpandedElement(row: any) {
    if (row.STTRG === '1') {
      return;
    }
    if (this.expandedElement === row) {
      this.expandedElement = null;
    } else {
      this.expandedElement = row;
      this.movementBackImageSrc = `/forgasa-arino/api/movements/image/${moment(row.ENTRY_DATE).format('YYYYMMDD')}/${row.ENTRY_MOVE}/_F`;
      this.movementFrontImageSrc = `/forgasa-arino/api/movements/image/${moment(row.EXIT_DATE).format('YYYYMMDD')}/${row.EXIT_MOVE}/_F`;
      this.facialImageSrc = `/forgasa-arino/api/movements/image/${moment(row.ENTRY_DATE).format('YYYYMMDD')}/${row.ENTRY_MOVE}/_2`;
    }
  }

  edit(row: any) {
    if (row.STTRG !== '5') {
      const dialogRef = this.dialog.open(PrevisionDialogComponent, {
        width: '400px',
        disableClose: true,
        data: { row },
      });
      this.modifiedPrevisionSubscription = dialogRef.afterClosed().subscribe(
        value => {
          if (value) {
            console.log('value en edit function: ' + JSON.stringify(value));
            // tslint:disable-next-line:max-line-length
            const smsParams = {
              qr: value.QR,
              telefono: value.ZZMOVIL,
              NAME1: value.NAME1,
              ARKTX: value.ARKTX,
              TKNUM: value.TKNUM,
              VBELN: value.VBELN,
              date: value.DAREG,
            };
            // tslint:disable-next-line:max-line-length
            const bdParams = {
              ZZMOVIL: value.ZZMOVIL,
              EXTI2: value.EXTI2,
              EXTI1: value.EXTI1,
              frontPlate: value.frontPlate,
              rearPlate: value.rearPlate,
              SIGNI: value.frontPlate + ' ' + value.rearPlate,
              STTRG: value.STTRG,
            };
            this.modifyPrevisonSubscription = this.previsionsService.update(value.QR, bdParams as unknown as Prevision).subscribe(
              data => {
                this.snackBar.showSuccess(`Prevision actualizada correctamente: ${value.TKNUM}`);
                this.modifyPrevisonSubscription.unsubscribe();
                // tslint:disable-next-line:triple-equals
                if (row.STTRG == 1) {
                  setTimeout(() => {
                    this.sendSmsSubscription = this.smsService.sendSMS(smsParams).subscribe(
                      // tslint:disable-next-line:no-shadowed-variable
                      data => {
                        this.snackBar.showSuccess(`SMS enviado correctamente al ${value.ZZMOVIL}`);
                        this.sendSmsSubscription.unsubscribe();
                      },
                      err => {
                        console.log(err);
                        this.snackBar.showError(`Error enviando SMS al ${value.ZZMOVIL}`);
                        this.sendSmsSubscription.unsubscribe();
                      }
                    );
                  }, 3000);
                }
              },
              err => {
                this.snackBar.showError(`Error actualizando previson ${value.TKNUM}`);
                this.modifyPrevisonSubscription.unsubscribe();
              }
            );
          }
          this.modifiedPrevisionSubscription.unsubscribe();
        },
        err => {
          this.snackBar.showError(err);
          this.modifiedPrevisionSubscription.unsubscribe();
        }
      );
    } else if (row.STTRG === '2') {
      // TODO: Formulario para modificar la previsión si es STTRG = 2 Nota20/11/20 No hace falta implementarlo por ahora.
    }
  }

  public remove(prevision: any): void {
    const data: any = {
      title: 'Atención!',
      message: `Desea borrar la prevision ${prevision.TKNUM}?`,
      rightButtonText: 'Sí',
    };

    /*this.simpleDialogService.open(data).subscribe(response => {
      if (response) {
        this.previsionsService.delete(prevision.QR).subscribe(() => this.loadPrevisions());
      }
    });*/
  }

  private initTodayFilter() {
    // tslint:disable-next-line:no-string-literal
    this.filterForm.controls['todayFilter'].setValue(true);
    this.filter.today = true;
  }

  sync() {
    this.sincronized = !this.sincronized;
    if (this.sincronized) {
      // this.loadPrevisions();
      this.socketSincro();
    } else {
      this.syncPrevisionesListSubscription.unsubscribe();
    }
  }

  socketSincro() {
    this.syncPrevisionesListSubscription = this.wsService.listen('syncPrevisionesList').subscribe(
      data => {
        this.loadPrevisions();
      },
      err => {
        this.snackBar.showError(err);
      }
    );
  }
}
